export var FinancialNotificationEventType = /*#__PURE__*/ function(FinancialNotificationEventType) {
    FinancialNotificationEventType["ProjectBudgetThresholdReached"] = "ProjectBudgetThresholdReached";
    FinancialNotificationEventType["ProjectHoursThresholdReached"] = "ProjectHoursThresholdReached";
    return FinancialNotificationEventType;
}({});
export var RevenueRecognitionProjectLevelTypes = /*#__PURE__*/ function(RevenueRecognitionProjectLevelTypes) {
    RevenueRecognitionProjectLevelTypes["AllProjects"] = "ALL_PROJECT";
    RevenueRecognitionProjectLevelTypes["ProjectLevel"] = "PROJECT_LEVEL";
    return RevenueRecognitionProjectLevelTypes;
}({});
export var FixedFeeRevenueRecognitionTypes = /*#__PURE__*/ function(FixedFeeRevenueRecognitionTypes) {
    FixedFeeRevenueRecognitionTypes["TrackedHoursByProjectHours"] = "TRACKED_HOURS_BY_PROJECT_HOURS";
    FixedFeeRevenueRecognitionTypes["TrackedHoursByAllocatedHours"] = "TRACKED_HOURS_BY_ALLOCATED_HOURS";
    FixedFeeRevenueRecognitionTypes["TrackedHoursByEstimateAtCompletion"] = "TRACKED_HOURS_BY_ESTIMATE_AT_COMPLETION";
    FixedFeeRevenueRecognitionTypes["MilestoneBased"] = "MILESTONE_BASED";
    FixedFeeRevenueRecognitionTypes["Manual"] = "MANUAL";
    return FixedFeeRevenueRecognitionTypes;
}({});
export var CustomRevenueRecognitionTypes = /*#__PURE__*/ function(CustomRevenueRecognitionTypes) {
    CustomRevenueRecognitionTypes["CustomRevenueRecognition"] = "CUSTOM_REVENUE_RECOGNITION";
    return CustomRevenueRecognitionTypes;
}({});
export var SubscriptionRevenueRecognitionTypes = /*#__PURE__*/ function(SubscriptionRevenueRecognitionTypes) {
    SubscriptionRevenueRecognitionTypes["EndOfPeriod"] = "RECOGNISE_AT_END_OF_THE_PERIOD";
    SubscriptionRevenueRecognitionTypes["TrackedHoursByPeriodHours"] = "TRACKED_HOURS_BY_PERIOD_HOURS";
    SubscriptionRevenueRecognitionTypes["TrackedHoursByPeriodAllocatedHours"] = "TRACKED_HOURS_BY_PERIOD_ALLOCATED_HOURS";
    return SubscriptionRevenueRecognitionTypes;
}({});
export var TimeMaterialRevenueRecognitionTypes = /*#__PURE__*/ function(TimeMaterialRevenueRecognitionTypes) {
    TimeMaterialRevenueRecognitionTypes["AllTrackedHours"] = "ALL_TRACKED_HOURS";
    return TimeMaterialRevenueRecognitionTypes;
}({});
export var CustomRevRecDenominator = /*#__PURE__*/ function(CustomRevRecDenominator) {
    CustomRevRecDenominator["BudgetHours"] = "BUDGET_HOURS";
    CustomRevRecDenominator["EstimateAtCompletion"] = "ESTIMATE_AT_COMPLETION";
    CustomRevRecDenominator["AllocatedHours"] = "ALLOCATED_HOURS";
    return CustomRevRecDenominator;
}({});
